import { Vue, Component, Ref } from "vue-property-decorator";
import CurdForm from "./form";
import ImportButton from "../ImportButton/index.vue";
import ExportButton from "../ExportButton/index.vue";
import { cloneDeep } from "lodash";

interface Options {
  retrieve: (...args) => any;
  search?: (...args) => any;
  create: (...args) => any;
  update?: (...args) => any;
  delete: (...args) => any;
  placeFile?: (...args) => any;
  reset?: (...args) =>any;
}

@Component({
  CurdForm,
})
class BaseCurd extends Vue {
  @Ref() readonly _form_2: CurdForm;
  @Ref() readonly _form_1: CurdForm;

  acl;
  columns;
  schema;
  formInfo;
  count;
  name: string;
  options: Options;
  loading = false;
  showDialog = false;
  showDrawer = false;
  templateModalClass = "";
  editdata: any = {};
  dataSource = [];
  selectedIds = [];
  selectedRowKeys = []; // 复选框勾选，多选
  selectedRows = []; // 复选框勾选的数据项(所有字段的集合)
  selectRowKey = '' // 行点击，单选
  disabled = false
  filters = {
    total: 0,
    size: 30,
    current: 1,
  };
  keywords = '';
  hidden = [];
  // 是否展示归档
  isShowPlaceFile = false;
  isShowReset = false
  newResFlag = false
  scroll: any = {};
  printVisible = false
  dataList = []

  ie = false;
  downloadFn: (...args: any[]) => any = () => null;
  importFn: (...args: any[]) => any = () => null;
  type = ''
  importFilename = "";
  exportFn: (...args: any[]) => any = () => null;
  exportFilename = "";
  waitGetData = false;
  showSearch = true;
  showTableCheckbox = true;
  saveLoading = false;

  get createModalTitle() {
    return this.$t("create")
  }
  get createModalSaveBtn() {
    return this.$t("save")
  }

  get lang() {
    return {
      create: this.$t("create"),
      placeholder: this.$t("keyword"),
      search: this.$t("search"),
      delete: this.$t("delete"),
    };
  }

  get newColumns() {
    console.log(this.columns,'this.columns')
    let index = this.columns.findIndex(
      (item) => item.key === "action" || item.key === "operation"
    );
    if (index < 0 && !this.hidden.includes("edit")) {
      return [
        {
          title: this.$t("page_tenant_operation"),
          key: "action",
          fix: "left",
          width: 160,
          customRender: (text, record) => {
            return (record.id &&
              <div class="flex" >
                <a
                  href="javascript:;"
                  onclick={() => this.openEditWindow(record)}
                >
                  {this.$t("edit")}
                </a>
                {this.isShowPlaceFile ? ((<div class="flex"><a-divider type="vertical" style="top:5px;"/>
                <a-popconfirm
                  title={this.$t('page_place_is_not_on_file')}
                  onConfirm={() => this.placeFile(record)}
                  okText={this.$t("yes")}
                  cancelText={this.$t("no")}
                >
                  <a
                    href="javascript:;"
                    style="color:red"
                  >
                  {this.$t("page_place_on_file")}
                </a>
              </a-popconfirm>
              </div>)): null}
             {this.isShowReset?((<div class="flex"><a-divider type="vertical"   style="top:5px;"/>
              <a
                  href="javascript:;"
                  onclick={() => this.handleReset(record)}
                >
                  {this.$t("page_employee_reset")}
                </a>
                </div>)):null
             }
              </div>
            );
          },
        },
        ...this.columns,
      ];
    } else {
      return this.columns;
    }
  }

  created() {
    if (!this.waitGetData) {
      this.getData();
    }
  }

  rowSelection() {
    getCheckboxProps: (record) => ({
      style: {
        opacity: record.id == 'none' ? 0 : 1
      }
    })
  }

  async createData() {
    const data: any = await this._form_2.manualSubmit();
    this.saveLoading = true;
    const fetchFn = this.options.create;
    try {
      await fetchFn(data)
      this.saveLoading = false
      this.$message.success(this.$t('page_docdirectory_create_success'))
      this.disabled = false
      this.showDialog = false
      this.getData()
    } catch (e) {
      this.saveLoading = false
    }
  }

  async updateData() {
    const values: any = await this._form_1.manualSubmit()
    this.saveLoading = true
    const data = {
      ...this.editdata,
      ...values
    }
    const fetchFn = this.options.update
    try {
      await fetchFn(data)
      this.saveLoading = false
      this.$message.success(this.$t('page_docdirectory_edit_success'))
      this.showDrawer = false
      this.getData()
    } catch (e) {
      this.saveLoading = false
    }
  }

  async handleReset(record){
    let id =record.id 
   let resetFn= this.options.reset.bind(this);
    resetFn(id).then(res =>{
      if(res){
        this.$message.success(this.$t("page_reset_successfully"))
      }
    }).catch(err => {
      this.$message.error(err.msg)
    })
     this.getData()
    
  }
  async getData(
    current = this.filters.current,
    size = this.filters.size,
    keyWords = this.keywords,
    reload: any = false
  ) {
    this.loading = true;
    if (reload) current = 1;
    const fetchFn = this.options.retrieve.bind(this);
    // 展示归档的会多个状态的数组
    if (this.isShowPlaceFile) {
      const { records, total: t, size: s, current: c } =   await fetchFn(
        current,
        {statusList: [1]},
        keyWords,
        size
      ) ;
      const processWorkList = records
      processWorkList.forEach(item =>{
        let str = ""
        if(item.processWorkStationList){
         for (let i = 0; i < item.processWorkStationList.length; i++) {
           if(item.processWorkStationList.length > 1) {
             if(item.processWorkStationList.length-1 == i) {
               str = str + item.processWorkStationList[i].workStationCode
             }else {
               str = str + item.processWorkStationList[i].workStationCode +" ,"
             }
           } else {
             str = item.processWorkStationList[i].workStationCode
           } 
          }
          item.processWorkStationList = str
        }
         item["workStationIds"] = item.processWorkStationList
      })
      this.loading = false;
      let dataLength = processWorkList.length;
      let copy = cloneDeep(processWorkList);
      let needPush = 0;
      if(dataLength < 30) {
        needPush = 30 - dataLength;
        for(var k=0; k<needPush; k++) {
          let obj = {  
            // id: 'none'
          }
          copy.push(obj)  
        }
      }
      
      this.dataSource = cloneDeep(copy);
      this.filters = {
        total: Number(t),
        size: Number(s),
        current: Number(c),
      };
    } else {
      console.log('else')
      const { records, total: t, size: s, current: c } =   await fetchFn(
        current,
        keyWords,
        size
      );
      this.loading = false;
      
      let dataLength = records.length;
      let copy = cloneDeep(records);
      let needPush = 0;
      if(dataLength < 30) {
        needPush = 30 - dataLength;
        for(var k=0; k< needPush; k++) {
          let obj = {  
            // id: 'none'
          }
          copy.push(obj)  
        }
      }  
      this.dataSource = cloneDeep(copy);



      this.filters = {
        total: Number(t),
        size: Number(s),
        current: Number(c),
      };
    }
  }

  async deleteSingleData(data) {
    const fetchFn = this.options.delete;

    const { current } = this.filters;
    const restDataLength = this.dataSource.length - 1;

    await fetchFn(data);
    if(this.selectedRowKeys.length && data.length) {
      this.selectedRowKeys.map((id,index) => {
        data.map(item => {
          if(item === id) {
            this.selectedRowKeys.splice(index,1)
          }
        })
      })
    }
    this.$message.success(this.$t("page_user_management_delete_succeeded"));
    await this.getData(
      !restDataLength ? (current - 1 ? current - 1 : current) : current
    );
  }

  async deleteData() {
    const fetchFn = this.options.delete;

    const { current } = this.filters;
    const restDataLength = this.dataSource.length - this.selectedIds.length;
    console.log(111);
    
    await fetchFn(this.selectedIds);
    this.selectedIds = [];
    this.$message.success(this.$t("page_user_management_delete_succeeded"));
    await this.getData(
      !restDataLength ? (current - 1 ? current - 1 : current) : current
    );
    this.showDrawer = false;
  }

  async placeFile(record) {
    const fetchFn = this.options.placeFile;
    record.status = 0
    await fetchFn(record)
    this.$message.success(this.$t("page_place_on_file_success"));
    this.getData();
  }
  async getDataDetail(row) {
    const fetchFn = this.options.search;
    
    const { id } = row;
    let data;
    
    if (fetchFn) {
      data = await fetchFn(id);
      if(data.isBind == null || data.isBind == 'null'){
        data.isBind = 0
      }
      const processWorkList = data
      let arr = processWorkList.processWorkStationList
      let array = []
      if(arr) {
        for (let i = 0; i <arr.length; i++) {
            array.push(arr[i].workStationId)
          }
           arr =array
      }
        processWorkList["workStationIds"] = arr
    } else {
      data = row;
    }

    this.editdata = data;
  }

  pageIndexchange(current, pageSize) {
    const { size: s, current: c } = this.filters;
    const noChanged = current === c && pageSize === c;
    if (noChanged) return;
    this.filters.size = pageSize;
    this.filters.current = current;

    this.getData(current, pageSize);
  }

  onSelectChange(selectedRowKeys, selectedRows) {
    console.log('勾选：',selectedRowKeys, selectedRows)
    this.selectedRowKeys = selectedRowKeys;
    this.selectedRows = selectedRows;
    this.selectedIds = selectedRows.map((item) => item.id);
  }

  onSearch(value) {
    this.keywords = value;
    this.getData(undefined, undefined, value, true);
  }

  openEditWindow(row) {
    const { hidden } = this;
    const hide = hidden.includes("edit");
    if (hide) {
      this.editdata = row;
      return;
    }
    if (this.showDrawer) {
      this.$confirm({
        title: this.$t("switch_tips_title"),
        content: this.$t("switch_tips_content"),
        onOk: () => {
          this.getDataDetail(row);
          this.showDrawer = true;
        },
        onCancel() {
          return;
        },
      });
    } else {
      this.getDataDetail(row);
      this.showDrawer = true;
    }
  }

  openCreateWindow() {
    this.showDialog = true;
    this.showDrawer = false;
  }

  refresh() {
    this.filters.current = 1;
    this.getData();
  }
  cancelHandle() {
    this.showDialog = false
    this.disabled = false
  }
  handlerColse() {
    this.showDialog = false
    this.disabled = false
  }

  printing() {
    this.getList()
    this.printVisible = true
  }

  cancel() {
    this.selectedRowKeys = []
    this.selectedIds = []
    this.printVisible = false
  }
  handlerPrint() {
    this.selectedRowKeys = []
    this.selectedIds = []
    this.printVisible = false
  }

  getList() {
    this.dataList = []
    this.selectedRowKeys.map(id =>{
      this.dataSource.map(item => {
        if(id === item.id) {
          this.dataList.push({
            code: item.code,
            name: item.name
          })
        }
      })
    })
  }

  showTotal(total){
    return (this.$t('Total…items') as string).replace('{0}', total)
  }

  extraHeaderAction() {
    return [
      <ImportButton
        filename={this.importFilename}
        downloadFn={this.downloadFn}
        importFn={this.importFn}
        refresh={this.refresh}
        type={this.type}
        newResFlag={this.newResFlag}
        style="margin-left: 8px"
      />,
      <ExportButton
        simple
        filename={this.exportFilename}
        exportFn={this.exportFn}
        style="margin-left: 8px"
      />,
      <code-model
      visible={this.printVisible}
      onCancel={this.cancel}
      dataList={this.dataList}
      onprint={this.handlerPrint}
      >
      </code-model>,
    ]
  }

  renderHeader(slot = null) {
    const { hidden } = this;

    const add = hidden.includes("create") ? null : (
      <a-button
        v-acl={this.acl.create}
        type="primary"
        style={{ marginRight: "8px" }}
        onClick={this.openCreateWindow}
      >
        {this.lang.create}
      </a-button>
    );

    const del = hidden.includes("delete") ? null : (
      <a-popconfirm
        title={this.$t("page_resource_pool_confirm_delete")}
        onConfirm={this.deleteData}
        okText={this.$t("yes")}
        cancelText={this.$t("no")}
        disabled={this.selectedIds.length < 1}
      >
        <a-button
          v-acl={this.acl.delete}
          type="danger"
          disabled={this.selectedIds.length < 1}
        >
          {this.lang.delete}
        </a-button>
      </a-popconfirm>
    );
    const ie = [
      <ImportButton
        filename={this.importFilename}
        downloadFn={this.downloadFn}
        importFn={this.importFn}
        type={this.type}
        refresh={this.refresh}
        newResFlag={this.newResFlag}
        style="margin-left: 8px"
      />,
      <ExportButton
        simple
        filename={this.exportFilename}
        exportFn={this.exportFn}
        style="margin-left: 8px"
      />,
    ];
    return (
      <div
        slot="action"
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div>
          {add}
          {del}
          {this.ie ? this.extraHeaderAction() : null}
        </div>
        {this.showSearch ? ( <div style="display:flex;align-items:center">
          {slot}
          <a-input-search
            placeholder={this.lang.placeholder}
            onSearch={this.onSearch}
            enterButton={this.lang.search}
            allowClear={true}
          ></a-input-search>
        </div>) : null}
      </div>
    );
  }

  // 行点击
  rowClick(record) {
    /*return {
      on: {
        click: (event: any) => {
          this.selectedRowKeys = []
          this.selectedIds = []
          this.selectedRowKeys.push(record.id)
          this.selectedIds.push(record.id)
        },
      },
    }*/
  }

  getCheckboxProps(record) {
    return ({
      style: {
        display: record.id ? 'block' : 'none'
      },
      props: {
        disabled: record.id ? false : true
      }
    })
  }

  cancelChooseArr(val) {
    this.selectedRowKeys = [];
    this.selectedIds = [];
  }

  renderBody() {
    return (
      <div class="basecurd-body">
        <div class="temp-table-con" style="overflow-y:auto;overflow-x: hidden;">
          {this.showTableCheckbox ? <ml-table
            size="small"
            rowKey="id"
            defaultExpandAllRows={true}
            canChangeColWidth={true}
            // canFixedHead={true}
            loading={this.loading}
            dataSource={this.dataSource}
            columns={this.newColumns}
            scroll={this.scroll}
            custom-row={this.rowClick}
            rowSelection={{
              selectedRowKeys: this.selectedRowKeys,
              onChange: this.onSelectChange,
              getCheckboxProps: this.getCheckboxProps
            }}
            chooseArr={this.selectedRowKeys}
            onCancelChooseArr={this.cancelChooseArr}
            selectRowKey={(this.editdata && this.editdata.id)||this.selectRowKey }
          ></ml-table> :
            <ml-table
            size="small"
            rowKey="id"
            defaultExpandAllRows={true}
            canChangeColWidth={true}
            // canFixedHead={true}
            loading={this.loading}
            dataSource={this.dataSource}
            columns={this.newColumns}
            scroll={this.scroll}
            custom-row={this.rowClick}
            selectRowKey={(this.editdata && this.editdata.id)||this.selectRowKey }
          ></ml-table>}
        </div>
        <a-pagination
          showQuickJumper={false}
          showSizeChanger={false}
          show-total={total => `${ this.showTotal(total) }`}
          style="float:right;margin-top:20px;margin-right:20px;"
          total={this.filters.total}
          pageSize={this.filters.size}
          current={this.filters.current}
          onChange={this.pageIndexchange}
          onShowSizeChange={this.pageIndexchange}
        ></a-pagination>
      </div>
    );
  }

  renderDialog() {
    return (
      <a-modal
        class={this.templateModalClass}
        onCancel={this.cancelHandle}
        title={this.createModalTitle}
        visible={this.showDialog}
        destroyOnClose={true}
        maskClosable={false}
      >
        <div slot="footer">
          <a-button
            style="margin-right:8px"
            onClick={this.handlerColse}
          >
            {this.$t("cancel")}
          </a-button>
          <a-button type="primary" onClick={this.createData}  loading={this.saveLoading}>
            {this.createModalSaveBtn}
          </a-button>
        </div>
        <CurdForm
          acl={{
            save: this.acl.create,
          }}
          ref="_form_2"
          type="create"
          schema={this.schema}
          name={this.name}
          footer={false}
        />
      </a-modal>
    );
  }

  renderDrawer() {
    return (
      <a-modal
        title={this.$t("edit")}
        visible={this.showDrawer}
        onCancel={() => (this.showDrawer = false)}
        extraStyle={{ paddingBottom: "50px" }}
      >
        <CurdForm
          acl={{
            save: this.acl.update,
          }}
          ref="_form_1"
          type="edit"
          schema={this.schema}
          defaultValue={this.editdata}
          name={this.name}
          footer={false}
        />
        <div slot="footer">
          <a-button
            style="margin-right:8px"
            onClick={() => (this.showDrawer = false)}
          >
            {this.$t("cancel")}
          </a-button>
          <a-button type="primary" onClick={this.updateData} loading={this.saveLoading}>
            {this.$t("save")}
          </a-button>
        </div>
      </a-modal>
    );
  }
  renderPrint() {
      return (
        <code-model
          visible={this.printVisible}
          onCancel={this.cancel}
          dataList={this.dataList}
          onprint={this.handlerPrint}
          >
          </code-model>
        )
    }

  customRender() {
    return (
      <blank-view>
        {this.renderHeader()}
        <div id="material-type-console" style="height:100%">
          {this.renderBody()}
          {this.renderDialog()}
          {this.renderDrawer()}
          {this.renderPrint()}
        </div>
      </blank-view>
    );
  }

  customTableRender() {
    return (
      <blank-view>
        {this.renderHeader()}
        <div style="height:100%">
          {this.renderBody()}
          {this.renderTableAdd()}
          {this.renderDrawer()}
          {this.renderPrint()}
        </div>
      </blank-view>
    );
  }

  renderTableAdd(){
    return (
      <a-modal
        class={this.templateModalClass}
        onCancel={this.cancelHandle}
        title={this.createModalTitle}
        visible={this.showDialog}
        destroyOnClose={true}
        maskClosable={false}
        width={1100}
      >
        <div slot="footer">
          <a-button
            style="margin-right:8px"
            onClick={this.handlerColse}
          >
            {this.$t("cancel")}
          </a-button>
          <a-button type="primary" onClick={this.createDataA}  loading={this.saveLoading}>
            {this.createModalSaveBtn}
          </a-button>
        </div>
        <ml-table
          size="small"
          rowKey="key"
          dataSource={this.formInfo}
          columns={this.schema}
          scroll={{ y: 300 }}
        ></ml-table>
        <a-button type="primary" style="width: 100%;margin-top: 8px" onClick={this.handleAdd}><a-icon type="plus" />{this.$t('page_material_warehousing_add_material')}</a-button>
      </a-modal>

    );
  }

  handleAdd(){
    const { count, formInfo } = this;
    const newData = {
      key: count,
      materialId: '',
      checkTypeName: '',
      lowerLimit: '',
      upperLimit: '',
      typeName: '',
      unit: '',
      stuff: '',
      remark: '',
      nameCode: ''
    };
    this.formInfo = [...formInfo, newData];
    this.count = count + 1;
  }

  async createDataA() {
    console.log(this.formInfo,'ddds')
  }

  getAcl(acl) {
    const buttons = this.$store.getters.buttons;
    return buttons.includes(acl);
  }
}

export default BaseCurd;
